import mixpanel from "mixpanel-browser"
import { DIAGNOSES_EVENTS } from "."

interface StartDiagnosisSessionProps {
  startDate: string
  userName: string
  userEmail: string
  subthemeId: string
}

export function startDiagnosisSession(props: StartDiagnosisSessionProps) {
  return mixpanel.track(DIAGNOSES_EVENTS.START_DIAGNOSIS_SESSION, {
    ...props,
  })
}
